import React from 'react';
import { Link } from 'gatsby';
import { styled } from 'twin.macro';

export const FormatLink = link => {
    return link
        ? link
              .replace('/case-studies', '/our-work')
              .replace('//home', '')
              .replace('/home', '')
              .replace('/menu-config', '')
        : '/';
};

export const DynamicLink = ({
    link,
    component,
    title,
    children,
    target,
    props,
    level,
    className
}) => {
    const url = FormatLink(link?.route?.path || link?.url);
    const targetContent = target ? target : link?.target ? '_blank' : null;
    const label = title || link?.title;

    // Extract ALL custom props that shouldn't be passed to DOM
    const { isLetsTalk, ...domSafeProps } = props || {};

    if (url) {
        if (
            url.includes('http') ||
            url.includes('tel:') ||
            url.includes('mailto:')
        ) {
            // Create styled component with shouldForwardProp to filter custom props
            const Elem = styled('a', {
                shouldForwardProp: (prop) => prop !== 'isLetsTalk'
            })`
                ${component?.__emotion_styles}
            `;
            return (
                <Elem
                    href={url}
                    target={targetContent}
                    title={label}
                    isLetsTalk={isLetsTalk}
                    level={level}
                    className={className}
                    {...domSafeProps}
                >
                    {children}
                </Elem>
            );
        } else {
            const Elem = styled(Link, {
                shouldForwardProp: prop => prop !== 'isLetsTalk',
            })`
                ${component?.__emotion_styles}
            `;
            return (
                <Elem
                    to={url}
                    target={targetContent}
                    title={label}
                    isLetsTalk={isLetsTalk}
                    level={level}
                    className={className}
                    {...domSafeProps}
                >
                    {children}
                </Elem>
            );
        }
    }
    return <></>;
};
